import { Flex } from '@dnb/eufemia';
import { useOutletContext, useParams } from 'react-router-dom';

import { ApiProviderPageOutletContext } from '@/pages/profile/apps/application/ApiProviderPage';

import LifecycleManagementSection from './LifecycleManagementSection';

export function LifecycleManagementTab() {
  const { api } = useOutletContext<ApiProviderPageOutletContext>();
  const { appId } = useParams();

  if (!appId) return;

  return (
    <Flex.Stack wrap={false}>
      <LifecycleManagementSection api={api} appId={appId} />
    </Flex.Stack>
  );
}
